module.exports = __webpack_public_path__ + "img/53.9e96b1da.ad99116d.svg";